export const MatDialogSize = {
  height: '90%',
  maxHeight: '90vh',
  maxHeightLogin: 'auto',
  width: '600px',
  mediumWidth: '800px',
  largeWidth: '1000px',
  minHeight: '400px',
  mediumHeight: '750px'
};
